import React, { useId, useState } from 'react';
import { Button, Collapse, Nav } from 'react-bootstrap';

import Icon from '~/components/icons/Icon';

type Props = {
  title: string;
  links: { label: string; href: string }[];
  twoColumns?: boolean;
};

const LinksNav = ({ title, links, twoColumns }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const id = useId();

  const toggleIconName = isOpen ? 'minus' : 'add';

  React.useEffect(() => {
    const mediaQuery = window.matchMedia('(min-width: 992px)');
    const handleMediaQueryChange = (e: MediaQueryListEvent) => {
      if (e.matches) {
        setIsOpen(true);
      } else {
        setIsOpen(false);
      }
    };

    if (mediaQuery.matches) {
      setIsOpen(true);
    }

    mediaQuery.addEventListener('change', handleMediaQueryChange);

    return () => {
      mediaQuery.removeEventListener('change', handleMediaQueryChange);
    };
  }, []);

  const navLinks = links.map((link, index) => (
    <Nav.Link href={link.href} className="p-0 mb-3 text-reset opacity-75" key={index}>
      {link.label}
    </Nav.Link>
  ));

  return (
    <div className="footer-links-nav">
      <Button
        variant="link"
        className="d-flex justify-content-between align-items-center w-100 border-0 px-0 footer-heading fw-semibold text-decoration-none text-uppercase text-reset"
        onClick={() => {
          if (window.matchMedia('(max-width: 991.98px)').matches) {
            setIsOpen(!isOpen);
          }
        }}
        aria-expanded={isOpen}
        aria-controls={id}
      >
        <span>{title}</span>
        <Icon name={toggleIconName} size={24} className="d-lg-none" />
      </Button>
      <Collapse in={isOpen}>
        <div id={id}>
          {twoColumns ? (
            <div className="d-xl-flex gap-xl-5">
              <Nav className="flex-column">{navLinks.slice(0, Math.ceil(navLinks.length / 2))}</Nav>
              <Nav className="flex-column">{navLinks.slice(Math.ceil(navLinks.length / 2))}</Nav>
            </div>
          ) : (
            <Nav className="flex-column">{navLinks}</Nav>
          )}
        </div>
      </Collapse>
    </div>
  );
};

export default LinksNav;
